import { Box } from '@mui/material';
import ReceivedRequestCard from 'FeatureModules/Home/Components/Requests/ReceivedRequestCard';
import useDialog from 'hooks/useDialog';
import RequestTitle from 'FeatureModules/Request/Components/RequestTitle';
import { DialogDefault, ThemeButton } from 'DesignSystem';
import Icon from 'DesignSystem/Primitives/Icon/Icon';
import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { IDefaultDialogProps } from 'types/dialog.types';
import {
  EPartnerRequestStatus,
  ERequestType,
  IPartnerRequest,
  TRequestType,
} from 'FeatureModules/Partner/types/partner.types';
import { REQUEST_STATUS_PARTNER } from 'FeatureModules/Request/utils/requestStatus.utils';

interface IManageRequestDialogProps extends IDefaultDialogProps {
  request: IPartnerRequest;
}

const ManageRequestDialog: FC<IManageRequestDialogProps> = ({ onClose, request }) => {
  const { openDialog } = useDialog();
  const navigate = useNavigate();

  const getButtonEvent = (requestType: TRequestType) => {
    switch (requestType) {
      case ERequestType.DOCUMENT:
        return () => {
          openDialog({
            type: 'UPLOAD_REQUEST',
            props: { requestId: request.id },
          });
          onClose?.();
        };
      case ERequestType.CHAIN:
        return () => {
          navigate(`/component-chains/${request.chainId}/editor`);
          onClose?.();
        };
      case ERequestType.QUESTIONNAIRE:
        return () => {
          navigate(
            `/questionnaires/${request.questionnaireId}/answers/${request.questionnaireCompanyResponseId}`
          );
          onClose?.();
        };
      default:
        return () => onClose?.();
    }
  };

  const buttonEvent = getButtonEvent(request.requestType);

  const handleDismissRequest = () => {
    openDialog({
      type: 'DENY_REQUEST',
      props: { requestId: request.id },
    });
    onClose?.();
  };

  return (
    <DialogDefault
      open
      title="Manage request"
      onClose={onClose}
      maxWidth="sm"
      iconName={
        REQUEST_STATUS_PARTNER[request.requestType][EPartnerRequestStatus[request.requestStatus]]
          .iconName
      }
      data-testid="manage-request-dialog"
    >
      <Box px={3} py={1} mb={2} minWidth={480}>
        <RequestTitle request={request} />
        <Box mt={2} />
        <ReceivedRequestCard request={request} displayActions={false} />
        <Box mt={3} display="flex" alignItems="center" justifyContent="space-between">
          {/* TODO: Remove dismiss button when the feature forwarding a request is implemented */}
          <ThemeButton
            color="BLUE_ICE"
            size="large"
            data-testid="dismiss-request-btn"
            onClick={handleDismissRequest}
            startIcon={
              <Icon
                name={
                  REQUEST_STATUS_PARTNER[request.requestType][EPartnerRequestStatus.DENIED].iconName
                }
              />
            }
          >
            Dismiss request
          </ThemeButton>
          <ThemeButton
            size="large"
            onClick={buttonEvent}
            data-testid="fulfill-request-btn"
            startIcon={
              <Icon
                name={
                  REQUEST_STATUS_PARTNER[request.requestType][EPartnerRequestStatus.EDITED].iconName
                }
                color="WHITE"
              />
            }
          >
            {
              REQUEST_STATUS_PARTNER[request.requestType][
                EPartnerRequestStatus[request.requestStatus]
              ].actionText
            }
          </ThemeButton>
        </Box>
        {/* TODO: Add this back in when the feature forwarding a request is implemented */}
        {/* <Box mt={2}>
          <ThemeTypography variant="BODY_MEDIUM_BOLD" color="GRAY_80">
            If you do not currently have this data, you can also forward this request to your
            sub-supplier or other partner, or you can respond by dismissing the request.
          </ThemeTypography>
        </Box>
        <Box display="flex" alignItems="center" justifyContent="space-between" mt={3}>
          <ThemeButton color="BLUE_ICE" size="large" onClick={handleDismissRequest}>
            Dismiss request
          </ThemeButton>
          <ThemeButton color="BLUE_ICE" size="large" startIcon={<Icon name="document-request-forward" />}>
            Forward request
          </ThemeButton>
        </Box> */}
      </Box>
    </DialogDefault>
  );
};

export default ManageRequestDialog;
